<script lang="ts">
    import { icon, icon50 } from '@otto-ec/icons';
    import type { OcIconButtonV2Props } from '@otto-ec/otto-components/icon-button';
    import type { Badge } from '@shared/types/types';

    interface Props {
        badges: Badge[] | undefined;
    }

    const { badges }: Props = $props();

    type IconName = keyof typeof icon | keyof typeof icon50;

    function isIconName(value: string): value is IconName {
        return value in icon || value in icon50;
    }

    function iconName(iconClass: Badge['iconClass']): OcIconButtonV2Props['icon'] {
        /*                                                                                              */
        /*                                                                  */
        const name = iconClass.replace('pl_icon_', '');
        return isIconName(name) ? name : 'info';
    }
</script>

{#if badges && badges.length > 0}
    {@const badge = badges[0]}
    <oc-icon-button-v2
        class="reptile-sustainability-badge"
        icon={iconName(badge.iconClass)}
        icon-color="var(--oc-semantic-color-sustainable-100)"
        oc-aria-label={badge.displayName}
        variant="transparent"
        data-oc-sheet-v1-create
        data-oc-sheet-v1-create.headline="Was bedeutet dieses Zeichen?"
        data-oc-sheet-v1-create.base64-url={btoa(badge.explanatoryTextUrl)}
    ></oc-icon-button-v2>
{/if}
